class ShippingDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawerClass = "wt-shipping-drawer";
    this.drawer = this;
    this.classDrawerActive = `${this.drawerClass}--open`;
    this.pageOverlayClass = "page-overlay-shipping";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;

    this.triggerQuery = [
      ".drawer--trigger",
      ".wt-shipping-drawer__close",
      `.${this.pageOverlayClass}`, 
    ].join(", ");

    this.isOpen = false;
    /*
    this.mainTrigger =
      document.querySelector(".wt-featured-icon__text") || null;
      */
  }

  connectedCallback() {
    this.init();
  }

  getFocusableElements() {
    const focusableSelector = "button, [href], input, select, [tabindex]";
    const focusableElements = Array.from(
      this.querySelectorAll(focusableSelector),
    ).filter((el) => !el.hasAttribute("disabled") && el.tabIndex >= 0);

    return {
      first: focusableElements[0],
      last: focusableElements[focusableElements.length - 1],
    };
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
    setTimeout(() => {
      document.body.classList.remove("no-focus-visible");
    }, 200);
  }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      this.isOpen = false;
      if (this.mainTrigger) this.mainTrigger.focus();
    } else {
      this.setAttribute("open", "");
      this.isOpen = true;
      const closeBtn = this.querySelector(".wt-shipping-drawer__close");
      if (closeBtn) closeBtn.focus();
    }
    this.temporaryHideFocusVisible();
  }

  toggleDrawerClasses() {
    this.onToggle();
    this.drawer.classList.toggle(this.classDrawerActive);
    console.log(this.body)
    this.body.classList.toggle(this.activeOverlayBodyClass);
  }

  setActiveTab(tabKey) {
    const tabTriggers = this.querySelectorAll(
      ".wt-shipping-drawer__tab__trigger",
    );
    const tabContents = this.querySelectorAll(
      ".wt-shipping-drawer__tab__content",
    );

    tabTriggers.forEach((t) =>
      t.classList.remove("wt-shipping-drawer__tab__trigger--active"),
    );
    tabContents.forEach((c) => c.classList.remove("is-active"));

    const matchingTrigger = this.querySelector(`[data-tab-target="${tabKey}"]`);
    if (matchingTrigger) {
      matchingTrigger.classList.add(
        "wt-shipping-drawer__tab__trigger--active",
      );
    }

    const matchingContent = this.querySelector(
      `[data-tab-content="${tabKey}"]`,
    );
    if (matchingContent) {
      matchingContent.classList.add("is-active");
    }
  }

  init() {
    // Trap focus & close on Escape
    this.addEventListener("keydown", (e) => {
      if (!this.isOpen) return;
      const { first, last } = this.getFocusableElements();
      const isTab = e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const isEsc =
        e.key === "Escape" || e.keyCode === 27 || e.code === "Escape";

      if (isEsc) {
        e.preventDefault();
        this.toggleDrawerClasses();
      } else if (isTab) {
        // Focus trap
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    document.querySelectorAll(this.triggerQuery).forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        const newTitle = trigger.querySelector('div.drawer__trigger-tittle')?.innerHTML || '';
        const newContent = trigger.querySelector('div.drawer__trigger-content')?.innerHTML || '';

        const drawer = document.querySelector('.wt-shipping-drawer'); 
        const titleElem = drawer.querySelector('.wt-drawer__title__text');
        const contentElem = drawer.querySelector('.wt-shipping-drawer__body');

        if (titleElem) titleElem.innerHTML = newTitle;
        if (contentElem) contentElem.innerHTML = newContent;

        const openTab = trigger.dataset.openDrawer;

        this.toggleDrawerClasses();

        if (openTab) {
          this.setActiveTab(openTab);
        }
      });
    });

  }
}

customElements.define("shipping-drawer", ShippingDrawer);
